<template>
    <dash
        icon="fa fa-file-text-o"
        titulo="CONTRATOS GESCON"
        @click.native="$router.push(rota)"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    props: {
        rota: {
            type: Object,
            default: () => ({
                name: 'FornecedorContratos'
            })
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
